<template>
  <div class="home-page">
    <div class="main-content">
      <!-- 第一部分：英雄区域 -->
      <section class="hero-section">
        <div class="container">
          <AppHeader />
          
          <div class="hero-content">
            <img src="@/assets/image/hero-slogan@2x.png" alt="闻讼咨询" class="slogan animate">
            <h2 class="hero-subtitle animate">500强企业的全国诉讼争议解决机构</h2>
            <!-- <div class="divider animate"></div> -->
            
            <div class="stats animate">
              <div class="stat-item">
                <div class="stat-number">{{websiteConfig.fwaj_allnum}}+</div>
                <div class="stat-text">服务案件</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{websiteConfig.fgcs_num}}+</div>
                <div class="stat-text">覆盖地市</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{websiteConfig.yszl_num}}+</div>
                <div class="stat-text">优势案由</div>
              </div>
              <div class="stat-item">
                <div class="stat-number">{{websiteConfig.fwhz_num}}+</div>
                <div class="stat-text">500强企业法务人员合作</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 第二部分：公司介绍 -->
      <section class="about-section" ref="aboutSection">
        <div class="container">
          <div class="about-content animate-scroll">
            <div class="titleMain">
              <h2 class="about-title">走进闻讼</h2>
              <div class="moveText" @click="goToAbout">more</div>
            </div>
            <p class="about-text">闻讼咨询服务（北京）有限公司成立于2022年，是一家专注于法律服务的科技企业。公司成立以来通过为企业提供"全国诉讼案管服务"、"企业数字风险感知与治理报告"、"企业法律实务研究咨询"等服务产品，为众多头部企业提供长期服务。</p>
          </div>
          <div class="about-image animate-scroll" style="animation-delay: 0.3s;">
            <img src="@/assets/image/bitmap2@2x.png" alt="走进闻讼">
          </div>
        </div>
      </section>

      <!-- 第三部分：服务特色 -->
      <section class="service-section" ref="serviceSection">
        <div class="container">
          <div class="titleMain">
            <h2 class="section-title animate-scroll">让法律更好地服务每个企业</h2>
            <div class="moveText animate-scroll" @click="goToBusiness">more</div>
          </div>
        </div>
        
        <div class="service-cards">
          <!-- 全国律师卡片 -->
          <div class="service-card animate-scroll" style="animation-delay: 0.1s;">
            <div class="card-header">
              <img src="@/assets/image/lawyer@2x.png" alt="全国律师" class="card-icon">
              <h3 class="card-title">全国律师</h3>
            </div>
            
            <div class="card-divider"></div>
            
            <div class="card-features">
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="全国范围" class="feature-icon">
                <span class="feature-text">全国范围</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="专业律师" class="feature-icon">
                <span class="feature-text">专业律师</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="专业遴选" class="feature-icon">
                <span class="feature-text">专业遴选</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="专业领域" class="feature-icon">
                <span class="feature-text">专业领域</span>
              </div>
            </div>
          </div>
          
          <!-- 案件管理卡片 -->
          <div class="service-card animate-scroll" style="animation-delay: 0.3s;">
            <div class="card-header">
              <img src="@/assets/image/case-manage@2x.png" alt="案件管理" class="card-icon">
              <h3 class="card-title">案件管理</h3>
            </div>
            
            <div class="card-divider"></div>
            
            <div class="card-features">
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="数字管理" class="feature-icon">
                <span class="feature-text">数字管理</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="案件协作" class="feature-icon">
                <span class="feature-text">案件协作</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="信息安全" class="feature-icon">
                <span class="feature-text">信息安全</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="实时进展" class="feature-icon">
                <span class="feature-text">实时进展</span>
              </div>
            </div>
          </div>
          
          <!-- 精细化运营卡片 -->
          <div class="service-card animate-scroll" style="animation-delay: 0.5s;">
            <div class="card-header">
              <img src="@/assets/image/operate@2x.png" alt="精细化运营" class="card-icon">
              <h3 class="card-title">精细化运营</h3>
            </div>
            
            <div class="card-divider"></div>
            
            <div class="card-features">
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="案件统筹" class="feature-icon">
                <span class="feature-text">案件统筹</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="线索调查" class="feature-icon">
                <span class="feature-text">线索调查</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="标准流程" class="feature-icon">
                <span class="feature-text">标准流程</span>
              </div>
              <div class="feature-item">
                <img src="@/assets/image/auth@2x.png" alt="成本可控" class="feature-icon">
                <span class="feature-text">成本可控</span>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <!-- 第四部分：法律知识库 -->
      <section class="knowledge-section" ref="knowledgeSection">
        <div class="container">
          <h2 class="section-title animate-scroll">闻讼法律知识库</h2>
          
          <div class="knowledge-list animate-scroll">
            <div v-if="loading" class="loading">加载中...</div>
            <template v-else>
              <div v-if="articles.length === 0" class="no-data">
                暂无文章数据
              </div>
              <div class="knowledge-row" v-for="(row, rowIndex) in articleRows" :key="rowIndex" v-else>
                <div class="knowledge-item"
                     v-for="(article, index) in row"
                     :key="article.id"
                     :style="{'animation-delay': `${0.1 * (rowIndex * 2 + index)}s`}"
                     @click="goToArticleDetail(article.id)">
                  <div class="knowledge-image">
                    <img :src="article.cover || require('@/assets/image/knowledge-bg@2x.png')" :alt="article.title">
                  </div>
                  <div class="knowledge-content">
                    <div class="knowledge-date">{{formatDate(article.publish_time)}}</div>
                    <div class="knowledge-title">{{article.title}}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          
          <div class="view-more-btn animate-scroll" style="animation-delay: 0.7s;">
            <button @click="viewMoreArticles">查看全部</button>
          </div>
        </div>
      </section>
    </div>
    
    <!-- 悬浮联系图标 -->
    <!-- <div
      class="floating-contact"
      ref="floatingContact"
      :style="{ left: contactPosition.x + 'px', top: contactPosition.y + 'px' }"
      @mousedown="handleMouseDown"
    >
      <img src="@/assets/image/contact-icon@2x.png" alt="联系我们" class="contact-icon">
    </div> -->
    
    <!-- 联系弹窗 -->
    <ContactModal
      :visible="showContactModal"
      @close="closeContactModal"
    />
    
    <div class="footer-wrapper">
      <AppFooter />
    </div>
  </div>
</template>

<script>
import AppFooter from '@/components/AppFooter.vue';
import AppHeader from '@/components/AppHeader.vue';
import ContactModal from '@/components/ContactModal.vue';
import { getArticleList, getWebsiteConfig } from '@/api';
import { RESPONSE_CODE } from '@/api/constants';

export default {
  name: 'HomePage',
  components: {
    AppFooter,
    AppHeader,
    ContactModal
  },
  data() {
    return {
      observers: [],
      articles: [],
      loading: false,
      params: {
        page: 1,
        limit: 6 // 首页只显示6篇文章
      },
      contactPosition: { x: window.innerWidth - 200, y: window.innerHeight - 200 },
      showContactModal: false,
      isDragging: false,
      dragOffset: { x: 0, y: 0 },
      dragStartTime: 0,
      mouseDownOnContact: false,
      // 网站配置数据
      websiteConfig: {
        company_name: '',
        company_description: '',
        service_cases: '5000+',
        coverage_cities: '500+',
        advantage_cases: '500+',
        cooperation_companies: '500+',
        contact_phone: '',
        contact_email: '',
        contact_address: ''
      },
      configLoading: false
    }
  },
  computed: {
    // 将文章列表按每行2篇进行分组
    articleRows() {
      const rows = [];
      for (let i = 0; i < this.articles.length; i += 2) {
        rows.push(this.articles.slice(i, i + 2));
      }
      return rows;
    }
  },
  mounted() {
    this.initScrollAnimations();
    
    // 首屏动画自动播放
    const animateElements = document.querySelectorAll('.animate');
    animateElements.forEach((el, index) => {
      setTimeout(() => {
        el.classList.add('visible');
      }, 300 * index);
    });

    // 获取文章列表
    this.fetchArticles();
    // 获取网站配置
    this.fetchWebsiteConfig();
    // 头部动画
    this.$nextTick(() => {
      const header = this.$el.querySelector('.logo-area.animate-scroll');
      if (header) header.classList.add('visible');
    });
    // 初始化悬浮图标位置
    this.initContactPosition();
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
    // 添加拖拽事件监听
    document.addEventListener('mousemove', this.handleMouseMove);
    document.addEventListener('mouseup', this.handleMouseUp);
  },
  beforeUnmount() {
    // 清理所有观察器
    this.observers.forEach(observer => {
      if (observer) {
        observer.disconnect();
      }
    });
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
    // 移除拖拽事件监听
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  },
  methods: {
    // 获取文章列表
    async fetchArticles() {
      this.loading = true;
      try {
        const res = await getArticleList(this.params);
        if (res.code === RESPONSE_CODE.SUCCESS_ALT) {
          this.articles = (res.data.data || []).map(item => ({
            id: item.id,
            title: item.title,
            cover: item.cover_image,
            publish_time: item.createtime
          }));
        } else {
          console.error('获取文章列表失败:', res.msg);
        }
      } catch (error) {
        console.error('获取文章列表失败:', error);
      } finally {
        this.loading = false;
      }
    },
    
    // 获取网站配置
    async fetchWebsiteConfig() {
      this.configLoading = true;
      try {
        const res = await getWebsiteConfig();
        if (res.code === RESPONSE_CODE.SUCCESS_ALT || res.code === RESPONSE_CODE.SUCCESS) {
          // 合并API返回的数据和默认数据，确保数据完整性
          const apiData = res.data || res.data?.data || {};
          this.websiteConfig = {
            ...this.websiteConfig,
            ...apiData
          };
          console.log('网站配置加载成功:', this.websiteConfig);
        } else {
          console.error('获取网站配置失败:', res.msg);
        }
      } catch (error) {
        console.error('获取网站配置失败:', error);
      } finally {
        this.configLoading = false;
      }
    },
    
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}`;
    },
    
    // 跳转到文章详情页
    goToArticleDetail(id) {
      this.$router.push(`/article/${id}`);
    },
    
    // 查看更多文章
    viewMoreArticles() {
      this.$router.push('/knowledge');
    },
    
    initScrollAnimations() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      };
      
      const sections = [
        this.$refs.aboutSection,
        this.$refs.serviceSection,
        this.$refs.knowledgeSection
      ];
      
      sections.forEach(section => {
        if (section) {
          const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                const animatedElements = entry.target.querySelectorAll('.animate-scroll');
                animatedElements.forEach(el => {
                  el.classList.add('visible');
                });
              }
            });
          }, options);
          
          observer.observe(section);
          this.observers.push(observer);
        }
      });
    },
    initContactPosition() {
      // 设置初始位置在右下角
      this.contactPosition = {
        x: window.innerWidth - 200,
        y: window.innerHeight - 200
      };
    },
    handleResize() {
      // 窗口大小变化时，确保悬浮图标在可视区域内
      const maxX = window.innerWidth - 60;
      const maxY = window.innerHeight - 60;
      
      this.contactPosition = {
        x: Math.min(this.contactPosition.x, maxX),
        y: Math.min(this.contactPosition.y, maxY)
      };
    },
    handleMouseMove(event) {
      if (this.dragStartTime > 0) {
        const moveDistance = Math.sqrt(
          Math.pow(event.clientX - (this.contactPosition.x + this.dragOffset.x), 2) +
          Math.pow(event.clientY - (this.contactPosition.y + this.dragOffset.y), 2)
        );
        
        // 如果移动距离超过5px，认为是拖拽
        if (moveDistance > 5) {
          this.isDragging = true;
        }
        
        if (this.isDragging) {
          const newX = event.clientX - this.dragOffset.x;
          const newY = event.clientY - this.dragOffset.y;
          
          // 确保图标不会拖出视窗
          const maxX = window.innerWidth - 84;
          const maxY = window.innerHeight - 84;
          
          this.contactPosition.x = Math.max(0, Math.min(newX, maxX));
          this.contactPosition.y = Math.max(0, Math.min(newY, maxY));
        }
      }
    },
    handleMouseUp() {
      // 只有在悬浮图标上按下鼠标且没有拖拽时，才认为是点击
      if (this.mouseDownOnContact && !this.isDragging) {
        this.openContactModal();
      }
      this.isDragging = false;
      this.dragStartTime = 0;
      this.mouseDownOnContact = false;
    },
    handleMouseDown(event) {
      this.isDragging = false;
      this.dragStartTime = Date.now();
      this.mouseDownOnContact = true;
      this.dragOffset = {
        x: event.clientX - this.contactPosition.x,
        y: event.clientY - this.contactPosition.y
      };
      event.preventDefault();
    },
    openContactModal() {
      this.showContactModal = true;
    },
    closeContactModal() {
      this.showContactModal = false;
    },
    
    // 跳转到关于我们页面
    goToAbout() {
      this.$router.push('/about');
    },
    
    // 跳转到业务页面
    goToBusiness() {
      this.$router.push('/business');
    }
  }
}
</script>

<style scoped>
.home-page {
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.footer-wrapper {
  flex-shrink: 0;
}

/* 入场动画基础样式 */
.animate, .animate-scroll {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 1s ease, transform 1s ease;
}

.animate.visible, .animate-scroll.visible {
  opacity: 1;
  transform: translateY(0);
}

/* 英雄区域样式 */
.hero-section {
  width: 1920px;
  height: 899px;
  background-image: url('~@/assets/image/hero-bg@2x.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
}

.container {
  width: 1200px;
  margin: 0 auto;
  /* padding: 0 360px; */
  position: relative;
}

.logo-area {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo {
  width: 109px;
  height: 40px;
  /* margin-left: 360px; */
}

.menu-icon {
  width: 24px;
  height: 24px;
  margin-left: 10px;
}

.hero-content {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.slogan {
  width: 902px;
  /* height: 66px; */
  margin-top: 120px;
}

.hero-subtitle {
  margin-top: 96px;
  font-weight: 600;
  font-size: 32px;
  color: #FFFFFF;
}

.divider {
  width: 30px;
  height: 4px;
  background: #FFFFFF;
  margin: 20px 0;
}

.stats {
  display: flex;
  margin-top: 20px;
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-item:not(:first-child) {
  margin-left: 41px;
}

.stat-number {
  font-weight: 600;
  font-size: 32px;
  color: #FFFFFF;
}

.stat-text {
  font-size: 16px;
  color: #FFFFFF;
  margin-top: 8px;
}

/* 公司介绍区域样式 */
.about-section {
  width: 1920px;
  height: 470px;
  background: #FFFFFF;
  display: flex;
  /* align-items: center; */
}

.about-section .container {
  display: flex;
  /* justify-content: space-between; */
  /* align-items: center; */
}

.about-content {
  max-width: 647px;
  padding-top: 40px;
}
.titleMain {
  display: flex;
  /* align-items: flex-end; */
}
.moveText {
  color: #999999;
  font-size: 18px;
  margin: 22px 0 0 10px;
  cursor: pointer;
}
.about-title {
  font-weight: 600;
  font-size: 36px;
  color: #333333;
}

.about-text {
  width: 585px;
  margin-top: 80px;
  font-weight: 400;
  font-size: 24px;
  color: #333333;
  line-height: 1.5;
}

.about-image {
  margin-left: 133px;
  display: flex;
  align-items: center;
}

.about-image img {
  width: 420px;
  height: 306px;
}

/* 服务特色部分样式 */
.service-section {
  width: 1920px;
  height: 424px;
  background: #F7F7F7;
  padding-top: 40px;
  overflow: hidden;
}

.service-section .container {
  width: 1200px;
  margin: 0 auto;
  padding: 0;
}

.section-title {
  font-weight: 600;
  font-size: 36px;
  color: #333333;
  text-align: left;
  margin-bottom: 40px;
}

.service-cards {
  display: flex;
  justify-content: space-between;
  width: 1200px;
  margin: 0 auto;
  gap: 24px;
  flex-wrap: nowrap;
  background: #FFFFFF;
  box-shadow: 0px 0 37px 0px #F2F2F2;
  border-radius: 4px;
}

.service-card {
  width: 384px;
  height: 254px;
  background: #FFFFFF;
  /* box-shadow: 0px 0 37px 0px #F2F2F2; */
  border-radius: 4px;
  padding: 40px 63px;
  flex-shrink: 0;
}

.card-header {
  display: flex;
  align-items: center;
}

.card-icon {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}

.card-title {
  font-weight: 500;
  font-size: 26px;
  color: #333333;
}

.card-divider {
  width: 258px;
  height: 1px;
  background: #F3F3F3;
  margin: 20px 0;
}

.card-features {
  display: flex;
  flex-wrap: wrap;
}

.feature-item {
  width: 50%;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.feature-icon {
  width: 22px;
  height: 22px;
  margin-right: 8px;
}

.feature-text {
  font-size: 20px;
  color: #666666;
}

/* 法律知识库部分样式 */
.knowledge-section {
  width: 1920px;
  height: 710px;
  background: #FFFFFF;
  padding-top: 40px;
  position: relative;
  overflow: hidden;
}

.knowledge-section::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 795px;
  height: 199px;
  background-image: url('~@/assets/image/knowledge-bg@2x.png');
  background-size: contain;
  background-position: right bottom;
  background-repeat: no-repeat;
  z-index: 1;
  opacity: 0.8;
}

.knowledge-section .container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}

.knowledge-list {
  margin-top: 40px;
}

.knowledge-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
}

.knowledge-item {
  width: 580px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.knowledge-item:hover {
  transform: translateY(-5px);
}

.knowledge-image {
  width: 180px;
  height: 130px;
  overflow: hidden;
  flex-shrink: 0;
}

.knowledge-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.knowledge-content {
  flex-grow: 1;
  padding-left: 20px;
}

.knowledge-date {
  font-size: 14px;
  color: #999999;
  margin-bottom: 10px;
}

.knowledge-title {
  font-size: 20px;
  color: #333333;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.view-more-btn {
  text-align: center;
  margin-top: 40px;
}

.view-more-btn button {
  width: 120px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #DDDDDD;
  border-radius: 4px;
  font-size: 16px;
  color: #333333;
  cursor: pointer;
}

/* 加载状态 */
.loading, .no-data {
  text-align: center;
  padding: 40px 0;
  font-size: 16px;
  color: #999;
}

/* 文章项添加鼠标悬停效果 */
.knowledge-item {
  cursor: pointer;
  transition: transform 0.3s ease;
}

.knowledge-item:hover {
  transform: translateY(-5px);
}

/* 悬浮联系图标样式 */
.floating-contact {
  position: fixed;
  z-index: 1000;
  cursor: pointer;
  transition: transform 0.2s ease;
  user-select: none;
}

.floating-contact:hover {
  transform: scale(1.1);
}

.floating-contact:active {
  transform: scale(0.95);
}

.contact-icon {
  width: 84px;
  height: 84px;
  /* border-radius: 50%; */
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); */
  /* transition: box-shadow 0.3s ease; */
}

.floating-contact:hover .contact-icon {
  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.25); */
}
</style>
